// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor5 from '@/game/prefabs/World/Mentors/Mentor5';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level23 extends TilemapScene {
  constructor() {
    super('Level23');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // tropical_biome_3
    const tropical_biome_3 = this.add.tilemap('tropical-biome-3');
    tropical_biome_3.addTilesetImage('tropical shores', 'tropical shores');
    tropical_biome_3.addTilesetImage(
      'tropical shores prefabs & samples',
      'tropical shores prefabs & samples',
    );
    tropical_biome_3.addTilesetImage(
      'tropical shores, just trees',
      'tropical shores, just trees',
    );
    tropical_biome_3.addTilesetImage('collision', 'collision & alpha');

    // terrain_1
    tropical_biome_3.createLayer(
      'terrain',
      ['tropical shores', 'tropical shores prefabs & samples'],
      0,
      0,
    );

    // deco_1
    tropical_biome_3.createLayer('deco', ['tropical shores'], 0, 0);

    // water_1
    tropical_biome_3.createLayer(
      'water',
      ['tropical shores prefabs & samples'],
      0,
      0,
    );

    // bushes_1
    tropical_biome_3.createLayer(
      'bushes',
      ['tropical shores, just trees'],
      0,
      0,
    );

    // tOP_trees_1
    tropical_biome_3.createLayer(
      'TOP trees',
      ['tropical shores, just trees'],
      0,
      0,
    );

    // cOLLISION_1
    const cOLLISION_1 = tropical_biome_3.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 176, 288);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 296, 264);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 568, 320);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 776, 448);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 184, 544);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 456, 576);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 488, 440);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 384, 608);
    this.add.existing(portal);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      88,
      288,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(
      this,
      184,
      256,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      248,
      320,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      360,
      432,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      296,
      432,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      232,
      432,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      168,
      432,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      104,
      432,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      40,
      432,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      360,
      576,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      296,
      576,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      232,
      576,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      168,
      576,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      104,
      576,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      40,
      576,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      360,
      640,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      296,
      640,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      232,
      640,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      168,
      640,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      104,
      640,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      40,
      640,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      360,
      720,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      296,
      720,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      232,
      720,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      168,
      720,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      104,
      720,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      40,
      720,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      744,
      432,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(
      this,
      808,
      416,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(
      this,
      104,
      336,
      'tropical_trees_sheet',
      1,
    );
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(
      this,
      424,
      416,
      'tropical_trees_sheet',
      1,
    );
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(
      this,
      472,
      400,
      'tropical_trees_sheet',
      1,
    );
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(
      this,
      600,
      416,
      'tropical_trees_sheet',
      1,
    );
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(
      this,
      168,
      272,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(
      this,
      536,
      352,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(
      this,
      440,
      512,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(
      this,
      488,
      512,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(
      this,
      536,
      512,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(
      this,
      584,
      512,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_37);

    // forestTree_38
    const forestTree_38 = new ForestTree1(
      this,
      632,
      512,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_38);

    // forestTree_39
    const forestTree_39 = new ForestTree1(
      this,
      648,
      560,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_39);

    // forestTree_40
    const forestTree_40 = new ForestTree1(
      this,
      600,
      560,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_40);

    // forestTree_41
    const forestTree_41 = new ForestTree1(
      this,
      552,
      560,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_41);

    // forestTree_42
    const forestTree_42 = new ForestTree1(
      this,
      504,
      560,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_42);

    // forestTree_43
    const forestTree_43 = new ForestTree1(
      this,
      456,
      560,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_43);

    // forestTree_44
    const forestTree_44 = new ForestTree1(
      this,
      440,
      640,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_44);

    // forestTree_45
    const forestTree_45 = new ForestTree1(
      this,
      504,
      640,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_45);

    // forestTree_46
    const forestTree_46 = new ForestTree1(
      this,
      568,
      640,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_46);

    // forestTree_47
    const forestTree_47 = new ForestTree1(
      this,
      632,
      640,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_47);

    // forestTree_48
    const forestTree_48 = new ForestTree1(
      this,
      696,
      640,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_48);

    // forestTree_49
    const forestTree_49 = new ForestTree1(
      this,
      760,
      640,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_49);

    // forestTree_50
    const forestTree_50 = new ForestTree1(
      this,
      824,
      640,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_50);

    // forestTree_51
    const forestTree_51 = new ForestTree1(
      this,
      664,
      672,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_51);

    // forestTree_52
    const forestTree_52 = new ForestTree1(
      this,
      728,
      672,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_52);

    // forestTree_53
    const forestTree_53 = new ForestTree1(
      this,
      792,
      672,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_53);

    // forestTree_54
    const forestTree_54 = new ForestTree1(
      this,
      472,
      672,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_54);

    // forestTree_55
    const forestTree_55 = new ForestTree1(
      this,
      536,
      672,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_55);

    // forestTree_56
    const forestTree_56 = new ForestTree1(
      this,
      600,
      672,
      'tropical_trees_sheet',
      9,
    );
    this.add.existing(forestTree_56);

    // forestTree_57
    const forestTree_57 = new ForestTree1(
      this,
      728,
      496,
      'tropical_trees_sheet',
      10,
    );
    this.add.existing(forestTree_57);

    // forestTree_58
    const forestTree_58 = new ForestTree1(
      this,
      776,
      496,
      'tropical_trees_sheet',
      10,
    );
    this.add.existing(forestTree_58);

    // forestTree_59
    const forestTree_59 = new ForestTree1(
      this,
      824,
      496,
      'tropical_trees_sheet',
      10,
    );
    this.add.existing(forestTree_59);

    // forestTree_60
    const forestTree_60 = new ForestTree1(
      this,
      728,
      528,
      'tropical_trees_sheet',
      10,
    );
    this.add.existing(forestTree_60);

    // forestTree_61
    const forestTree_61 = new ForestTree1(
      this,
      776,
      528,
      'tropical_trees_sheet',
      10,
    );
    this.add.existing(forestTree_61);

    // forestTree_62
    const forestTree_62 = new ForestTree1(
      this,
      824,
      528,
      'tropical_trees_sheet',
      10,
    );
    this.add.existing(forestTree_62);

    // forestTree_63
    const forestTree_63 = new ForestTree1(
      this,
      728,
      560,
      'tropical_trees_sheet',
      10,
    );
    this.add.existing(forestTree_63);

    // forestTree_64
    const forestTree_64 = new ForestTree1(
      this,
      776,
      560,
      'tropical_trees_sheet',
      10,
    );
    this.add.existing(forestTree_64);

    // forestTree_65
    const forestTree_65 = new ForestTree1(
      this,
      824,
      560,
      'tropical_trees_sheet',
      10,
    );
    this.add.existing(forestTree_65);

    // mentor
    const mentor = new Mentor5(this, 192, 224);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 248, 416);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 624, 432);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 680, 544);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 408, 312);
    this.add.existing(worldNode_9);

    // forestTree_66
    const forestTree_66 = new ForestTree1(
      this,
      360,
      496,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_66);

    // forestTree_67
    const forestTree_67 = new ForestTree1(
      this,
      296,
      496,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_67);

    // forestTree_68
    const forestTree_68 = new ForestTree1(
      this,
      232,
      496,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_68);

    // forestTree_69
    const forestTree_69 = new ForestTree1(
      this,
      168,
      496,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_69);

    // forestTree_70
    const forestTree_70 = new ForestTree1(
      this,
      104,
      496,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_70);

    // forestTree_71
    const forestTree_71 = new ForestTree1(
      this,
      40,
      496,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_71);

    // forestTree_72
    const forestTree_72 = new ForestTree1(
      this,
      840,
      432,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_72);

    // forestTree_73
    const forestTree_73 = new ForestTree1(
      this,
      840,
      400,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_73);

    // forestTree_74
    const forestTree_74 = new ForestTree1(
      this,
      760,
      384,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_74);

    // forestTree_75
    const forestTree_75 = new ForestTree1(
      this,
      728,
      384,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_75);

    // forestTree_76
    const forestTree_76 = new ForestTree1(
      this,
      680,
      416,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_76);

    // forestTree_77
    const forestTree_77 = new ForestTree1(
      this,
      680,
      352,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_77);

    // forestTree_78
    const forestTree_78 = new ForestTree1(
      this,
      600,
      432,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_78);

    // forestTree_79
    const forestTree_79 = new ForestTree1(
      this,
      552,
      400,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_79);

    // forestTree_80
    const forestTree_80 = new ForestTree1(
      this,
      424,
      432,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_80);

    // forestTree_81
    const forestTree_81 = new ForestTree1(
      this,
      232,
      320,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_81);

    // forestTree_82
    const forestTree_82 = new ForestTree1(
      this,
      264,
      304,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_82);

    // forestTree_83
    const forestTree_83 = new ForestTree1(
      this,
      216,
      272,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_83);

    // forestTree_84
    const forestTree_84 = new ForestTree1(
      this,
      168,
      320,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_84);

    // forestTree_85
    const forestTree_85 = new ForestTree1(
      this,
      72,
      288,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_85);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 22;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 22;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 22;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 22;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 22;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 22;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 22;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 22;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 22;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 22;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.tropical_biome_3 = tropical_biome_3;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor5;
  private tropical_biome_3!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.tropical_biome_3,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
